export enum MessageReactionEnum {
  NONE = 'NONE',
  THUMBS_UP = 'THUMBS_UP',
  LAUGH = 'LAUGH',
  LOVE = 'LOVE'
}
